import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { API } from "../../../../../shared/services";
import { useContacts, useContactsState } from "../../../contexts";
import { IconModal } from "../../IconModal";

function AfterRegisterSoldProduct() {
  const { currentContact, showModal } = useContactsState();
  const { setShowModal } = useContacts();

  const [open, setOpen] = useState(false);
  const { t } = useTranslation(["Customer"]);

  useEffect(() => {
    if (showModal == "after_sold" && !open) {
      setOpen(true);
    }
  }, [showModal]);

  function closeModal() {
    setOpen(false);
    setShowModal("");
  }

  function disableCustomer() {
    const ARCHIVE_STATUS = "filed";

    API.put(`customers/${currentContact.id}`, {
      customer: {
        status: ARCHIVE_STATUS,
      },
    })
      .then(() => {
        setOpen(false);
        setShowModal("");
        toast.success(t("details.archive.actionSuccess"));
      })
      .catch(() => {
        toast.success(t("details.archive.actionFail"));
      });
  }

  return (
    <IconModal
      title="Negócio fechado marcado com sucesso!"
      open={open}
      setOpen={setOpen}
    >
      <div style={{ marginTop: "30px", textAlign: "center" }}>
        <p>
          Este contato ainda está <strong>ativo</strong>.
        </p>
        <p>Como você marcou um negócio fechado,</p>
        <p>
          gostaria de <strong>inativar</strong> esse contato agora?
        </p>
      </div>

      <div
        style={{
          marginTop: 40,
          marginBottom: 20,
          marginLeft: "40px",
          marginRight: "40px",
        }}
      >
        <Button
          onClick={() => closeModal()}
          variant="outlined"
          color="primary"
          style={{ width: 191, marginRight: "10px" }}
        >
          Não arquivar, vou continuar conversando
        </Button>

        <Button
          onClick={() => disableCustomer()}
          variant="contained"
          color="primary"
          style={{ width: 191, marginLeft: "10px" }}
        >
          <strong>Arquivar esse contato</strong>
        </Button>
      </div>
    </IconModal>
  );
}

export default AfterRegisterSoldProduct;
